$(function () {
	if ($('.homeBannerCarousel__inner .slide').length > 1) {
		//main Banner carousel
		$('.homeBannerCarousel__inner').flickity({
			adaptiveHeight: false,
			autoPlay: 5000,
			cellAlign: 'left',
			contain: true,
			draggable: true,
			pageDots: true,
			prevNextButtons: false,
			pauseAutoPlayOnHover: false,
			setGallerySize: true,
			wrapAround: true,
			accessibility: true,
			imagesLoaded: true,
			on: {
				ready: function () {
					// Add pause button
					var pause = '<button class="flickity-button pause" type="button" aria-label="Pause alert carousel" aria-selected="false"></button>',
						dots = $('.flickity-page-dots .dot');

					$('.homeBannerCarousel__inner .flickity-page-dots').wrap('<div class="flickity-controls"/>');
					$(pause).insertAfter('.homeBannerCarousel__inner .flickity-page-dots');

					dots.each(function (index) {
						$(this).attr({
							'tabindex': 0,
							'aria-label': 'Go to slide ' + (index + 1)
						});
					});
				}
			}
		});

		$('.homeBannerCarousel__inner .flickity-button.pause').on('click', function () {
			let isPaused = $(this).attr('aria-selected') === 'true' ? true : false;

			$(this).attr('aria-selected', isPaused ? 'false' : 'true');
			$('.homeBannerCarousel__inner').flickity(isPaused ? 'playPlayer' : 'stopPlayer');
		});

		if (!window.matchMedia('(min-width: 1200px').matches) {
			$('.homeBannerCarousel__inner').flickity('stopPlayer');
		}
	}

	$(window).on('load', function () {
		var $social = $('.socialFeed-cta__social-feed').flickity({
			adaptiveHeight: false,
			autoPlay: false,
			cellAlign: 'left',
			contain: true,
			draggable: true,
			pageDots: false,
			prevNextButtons: true,
			pauseAutoPlayOnHover: false,
			setGallerySize: true,
			wrapAround: true,
			accessibility: true,
			imagesLoaded: true,
			on: {
				ready: function () {
					var btns = $('.socialFeed-cta__social-feed .flickity-button');

					if (btns.length) {
						btns.detach().appendTo('.socialFeed-cta__social-controls');
					}
				}
			}
		});

		$social.flickity('resize');

		if ($('.newsFeed .dateList-news .dateList_item').length > 3) {
			newsSlider();
		}

		if ($('.vehicleSlider__body .vehicleSlider__item').length > 3) {
			vehicleSlider();
		}
	});

	$(document).ajaxComplete(
		function () {
			if ($('.newsFeed .dateList-news .dateList_item').length > 3) {
				newsSlider();
			}

			if ($('.vehicleSlider__body .vehicleSlider__item').length > 3) {
				vehicleSlider();
			}
		}
	);

	function newsSlider() {
		var $newsSlider = $('.newsFeed .dateList-news').flickity({
			adaptiveHeight: false,
			autoPlay: false,
			cellAlign: 'center',
			contain: true,
			draggable: true,
			pageDots: true,
			prevNextButtons: false,
			pauseAutoPlayOnHover: false,
			setGallerySize: true,
			wrapAround: true,
			accessibility: true,
			imagesLoaded: true,
			on: {
				ready: function () {
					var dots = $('.newsFeed__body .flickity-page-dots .dot');

					dots.each(function (index) {
						$(this).attr({
							'tabindex': 0,
							'aria-label': 'Go to slide ' + (index + 1)
						});
					});
				}
			}
		});

		$newsSlider.flickity('resize');

		var newsFeeds = $('.newsFeed .dateList_link');
		newsFeeds.each(function (index) {
			var me = $(this),
				parent = me.closest('.dateList_item');

			me.on('keydown', function (e) {
				if (e.keyCode == 9) {
					if (e.shiftKey) {
						if (!parent.is(':first-child')) {
							e.preventDefault();

							$newsSlider.flickity('previous', true);

							setTimeout(function () {
								var anchors = newsFeeds.eq(index - 1);

								anchors.eq((anchors.length - 1)).trigger('focus');
							}, 100);
						}
					} else {
						if (!parent.is(':last-child')) {
							e.preventDefault();

							$newsSlider.flickity('next', true);

							setTimeout(function () {
								newsFeeds.eq(index + 1).eq(0).trigger('focus');
							}, 100);
						}
					}
				}
			});
		});
	}

	function vehicleSlider() {
		$('.vehicleSlider__body').flickity({
			adaptiveHeight: false,
			autoPlay: false,
			cellAlign: 'center',
			contain: true,
			draggable: true,
			pageDots: false,
			prevNextButtons: true,
			pauseAutoPlayOnHover: false,
			setGallerySize: true,
			wrapAround: true,
			accessibility: true,
			imagesLoaded: true,
			on: {
				ready: function () {

				}
			}
		});
	}
});